import React from 'react';
import { Section } from './ui/Section';
import { TropicalLeaf } from './botanical/TropicalLeaf';
export function ComparisonTable() {
  const rows = [{
    sit: 'Malestar que no conocés',
    sin: 'Buscás en Google',
    con: 'Mapa de decisión en segundos'
  }, {
    sit: 'Tenés niños en casa',
    sin: 'Usás dosis de adulto',
    con: 'Protocolo por edad listo'
  }, {
    sit: 'Querés instalar hábitos',
    sin: 'Empezás y abandonás',
    con: '30 días guiados paso a paso'
  }, {
    sit: 'Necesitás preparados listos',
    sin: 'Improvisás',
    con: 'Recetario maestro completo'
  }, {
    sit: 'Querés la referencia total',
    sin: 'Buscás en varios tomos',
    con: 'La Biblia lo tiene todo junto'
  }];
  return <Section className="bg-forest-mist relative overflow-hidden" data-id="element-94">
      <TropicalLeaf className="absolute -bottom-20 -left-20 w-[400px] h-[400px] text-moss opacity-5 blur-lg rotate-45" data-id="element-95" />

      <div className="max-w-4xl mx-auto relative z-10" data-id="element-96">
        <h2 className="text-2xl md:text-3xl font-serif font-bold text-center text-forest-deep mb-8 relative inline-block" data-id="element-97">
          ¿Qué suma el Super Pack?
          <svg className="absolute w-full h-2 -bottom-1 left-0 text-honey opacity-40" viewBox="0 0 100 10" preserveAspectRatio="none" data-id="element-98">
            <path d="M0 5 Q 50 10 100 5" stroke="currentColor" strokeWidth="4" fill="none" data-id="element-99" />
          </svg>
        </h2>

        <div className="md:hidden text-xs text-sage-deep text-center mb-2 flex items-center justify-center gap-2" data-id="element-100">
          <span data-id="element-101">← Scroll to see full table →</span>
        </div>

        <div className="overflow-x-auto pb-4 hide-scrollbar" data-id="element-102">
          <div className="min-w-[600px]" data-id="element-103">
            <table className="w-full text-left border-collapse bg-white/80 backdrop-blur-sm rounded-xl overflow-hidden border border-sage-mist" data-id="element-104">
              <thead data-id="element-105">
                <tr className="border-b-2 border-moss/20" data-id="element-106">
                  <th className="py-4 px-4 font-serif font-bold text-forest-deep w-1/3" data-id="element-107">
                    SITUACIÓN
                  </th>
                  <th className="py-4 px-4 font-serif font-bold text-forest/60 w-1/3" data-id="element-108">
                    SIN SUPER PACK
                  </th>
                  <th className="py-4 px-4 font-serif font-bold text-honey-dark w-1/3 bg-honey/10 rounded-tr-xl" data-id="element-109">
                    CON SUPER PACK
                  </th>
                </tr>
              </thead>
              <tbody data-id="element-110">
                {rows.map((row, idx) => <tr key={idx} className="border-b border-sage-mist/50 last:border-0 hover:bg-white/50 transition-colors" data-id="element-111">
                    <td className="py-4 px-4 font-medium text-forest-deep" data-id="element-112">
                      {row.sit}
                    </td>
                    <td className="py-4 px-4 text-forest/70" data-id="element-113">{row.sin}</td>
                    <td className="py-4 px-4 font-bold text-forest-deep bg-honey/5" data-id="element-114">
                      {row.con}
                    </td>
                  </tr>)}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </Section>;
}